module.exports = __webpack_public_path__ + "img/resources-article-pilates-massage@1x.85657e1c.jpg";